import React from 'react';
import Select from 'react-select';

export default function BaseSelect({
  value,
  onChange,
  className,
  options,
  components,
  isSearchable = true,
  open,
  isDisabled,
}) {
  return (
    <Select
      value={value}
      onChange={onChange}
      className={`react-select-container ${className}`}
      classNamePrefix="react-select"
      options={options}
      components={components}
      isSearchable={isSearchable}
      menuIsOpen={open} //-> good for testing ;
      isDisabled={isDisabled}
    />
  );
}
